/**
 * Arma el link corto visible para el vendedor. Si la marca definió un shortDomain
 * (Admin → Marca), lo usa; si no, cae al fallback (el shortUrl con el origin del deploy).
 * El dominio debe: (1) apuntar a esta app (custom domain/CNAME en el proyecto de Pages) y
 * (2) estar listado en `hostnames` del tenant correspondiente en D1 (tabla `tenants`).
 * Si falta lo segundo, `/r/{code}` resuelve por Host al tenant equivocado (o al legacy),
 * la key `t:<websiteId>:link:{code}` no matchea y el link cae silenciosamente a la home
 * de otra tienda — ver `docs/provisioning.md`.
 */
export function buildVisibleShortUrl(
  code: string,
  shortDomain: string | undefined,
  fallback: string
): string {
  const domain = shortDomain?.trim().replace(/^https?:\/\//i, '').replace(/\/+$/, '')
  if (!domain) return fallback
  return `https://${domain}/r/${code}`
}
